import React, { useState } from 'react';
import { Timer, Trash2, ChevronDown, ChevronUp } from 'lucide-react';
import { SWIMMING_STYLES } from '../../utils/constants';

const StudentDetailPerformanceTab = ({
  swimmingRecords,
  studentId,
  setActiveModal,
  handleDeleteSwimmingRecord,
}) => {
  const [expandedStyles, setExpandedStyles] = useState({});
  const [pendingDeleteRecordId, setPendingDeleteRecordId] = useState(null);

  const toggleStyleExpand = (style) =>
    setExpandedStyles((prev) => ({ ...prev, [style]: !prev[style] }));

  return (
    <>
      <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-4 mb-6 border-b border-slate-100 dark:border-slate-700 pb-4">
        <h3 className="font-bold text-lg text-slate-800 dark:text-white flex items-center gap-2">
          <Timer className="text-emerald-500 dark:text-emerald-400" /> Yüzme Dereceleri
        </h3>
        <button
          onClick={() => setActiveModal('newRecord')}
          className="text-emerald-600 dark:text-emerald-400 text-sm font-bold bg-emerald-50 dark:bg-emerald-900/30 hover:bg-emerald-100 dark:hover:bg-emerald-900/50 px-4 py-2 rounded-lg transition-colors text-center"
        >
          Derece Gir
        </button>
      </div>
      {swimmingRecords.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {SWIMMING_STYLES.map((style) => {
            const records = swimmingRecords
              .filter((r) => r.style === style)
              .sort((a, b) => b.timestamp - a.timestamp);
            if (records.length === 0) return null;
            return (
              <div
                key={style}
                className="border border-slate-100 dark:border-slate-700 rounded-2xl p-4 sm:p-5 bg-slate-50 dark:bg-slate-800/50"
              >
                <p className="text-sm font-bold text-slate-500 dark:text-slate-400 uppercase mb-3">
                  {style}
                </p>
                <div className="space-y-1.5">
                  {(expandedStyles[style] ? records : records.slice(0, 3)).map((r) => (
                    <div key={r.id} className="group">
                      {pendingDeleteRecordId === r.id ? (
                        <div className="flex items-center justify-between bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-xl px-3 py-2 gap-2">
                          <span className="text-[11px] font-bold text-red-600 dark:text-red-400">Silinsin mi?</span>
                          <div className="flex gap-1.5">
                            <button
                              onClick={() => {
                                handleDeleteSwimmingRecord(studentId, r.id);
                                setPendingDeleteRecordId(null);
                              }}
                              className="text-[11px] font-black text-white bg-red-500 hover:bg-red-600 px-2.5 py-1 rounded-lg transition-colors"
                            >
                              Evet
                            </button>
                            <button
                              onClick={() => setPendingDeleteRecordId(null)}
                              className="text-[11px] font-black text-slate-500 bg-slate-100 dark:bg-slate-700 hover:bg-slate-200 dark:hover:bg-slate-600 px-2.5 py-1 rounded-lg transition-colors"
                            >
                              Hayır
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div className="flex justify-between items-center text-xs font-bold text-slate-600 dark:text-slate-300 px-1 py-1 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700/50 transition-colors">
                          <span>{r.date}</span>
                          <div className="flex items-center gap-2">
                            <span>{r.time}</span>
                            <button
                              onClick={() => setPendingDeleteRecordId(r.id)}
                              className="opacity-0 group-hover:opacity-100 text-red-400 hover:text-red-600 transition-all p-0.5"
                              title="Dereceyi Sil"
                            >
                              <Trash2 size={12} />
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                {records.length > 3 && (
                  <button
                    onClick={() => toggleStyleExpand(style)}
                    className="mt-3 w-full flex items-center justify-center gap-1 text-[11px] font-bold text-blue-500 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors"
                  >
                    {expandedStyles[style] ? (
                      <><ChevronUp size={13} /> Daha Az Göster</>
                    ) : (
                      <><ChevronDown size={13} /> Tümünü Göster ({records.length})</>
                    )}
                  </button>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center py-12 bg-slate-50 dark:bg-slate-800/50 rounded-2xl border border-dashed border-slate-200 dark:border-slate-700">
          <Timer size={40} className="mx-auto text-slate-300 dark:text-slate-600 mb-4" />
          <p className="font-bold text-slate-500 dark:text-slate-400 mb-2">Henüz Derece Yok</p>
        </div>
      )}
    </>
  );
};

export default StudentDetailPerformanceTab;
